var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-callout",
    {
      staticClass: "mb-3 custom-callout results-callout",
      attrs: {
        "border-color": _vm.processStatus(_vm.process.batchStatusId),
        "has-toggle": false
      }
    },
    [
      _c("div", { staticClass: "row py-2" }, [
        _c(
          "div",
          { staticClass: "col-md-2 results-callout__status" },
          [
            _c("custom-balloon", {
              attrs: {
                "background-color": _vm.processStatus(
                  _vm.process.batchStatusId
                ),
                text: _vm.process.batchLoadStatusName
              }
            }),
            _c(
              "div",
              {
                staticClass:
                  "font-weight-normal color-secondary-6 font-14 mt-3 px-3"
              },
              [_vm._v(" Periodo: ")]
            ),
            _c("div", { staticClass: "color-black font-16 px-3" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.getMonth(_vm.process.monthNumber)) +
                  " " +
                  _vm._s(_vm.process.year) +
                  " "
              )
            ])
          ],
          1
        ),
        _c("div", { staticClass: "col-md-8 border-left pl-10" }, [
          _c("div", { staticClass: "row pt-4" }, [
            _c("div", { staticClass: "col-1" }, [
              _c(
                "div",
                { staticClass: "font-weight-normal color-secondary-6 font-14" },
                [_vm._v(" Servicio: ")]
              ),
              _c(
                "div",
                { staticClass: "color-black font-16 font-weight-bold" },
                [_vm._v(" " + _vm._s(_vm.process.batchLoadServiceName) + " ")]
              )
            ]),
            _c("div", { staticClass: "col ml-5 ml-md-1 ml-sm-0" }, [
              _c(
                "div",
                { staticClass: "color-secondary-6 font-14 font-weight-normal" },
                [_vm._v(" Fecha Creación: ")]
              ),
              _c(
                "div",
                { staticClass: "color-black font-16 font-weight-normal" },
                [
                  _vm._v(
                    " " + _vm._s(_vm._f("date")(_vm.process.createdDate)) + " "
                  )
                ]
              )
            ]),
            _c("div", { staticClass: "col ml-5 ml-md-1 ml-sm-0" }, [
              _c(
                "div",
                { staticClass: "color-gray-6 font-14 font-weight-normal" },
                [_vm._v(" Usuario Creación: ")]
              ),
              _c(
                "div",
                { staticClass: "color-black font-16 font-weight-normal" },
                [_vm._v(" " + _vm._s(_vm.process.createdBy) + " ")]
              )
            ]),
            _c("div", { staticClass: "col ml-5 ml-md-1 ml-sm-0" }, [
              _c(
                "div",
                { staticClass: "color-gray-6 font-14 font-weight-normal" },
                [_vm._v(" Fecha Actualización: ")]
              ),
              _c(
                "div",
                { staticClass: "color-black font-16 font-weight-normal" },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm._f("date")(_vm.process.modifiedDate, "dd MMM yyyy")
                      ) +
                      " "
                  )
                ]
              )
            ]),
            _c("div", { staticClass: "col ml-5 ml-md-1 ml-sm-0" }, [
              _c(
                "div",
                { staticClass: "color-gray-6 font-14 font-weight-normal" },
                [_vm._v(" Usuario Actualización: ")]
              ),
              _c(
                "div",
                { staticClass: "color-black font-16 font-weight-normal" },
                [_vm._v(" " + _vm._s(_vm.process.modifiedBy) + " ")]
              )
            ])
          ])
        ]),
        _c(
          "div",
          { staticClass: "col-md-2 text-right pr-5 pt-4" },
          [_c("drop-down", { attrs: { items: _vm.getProcessActions } })],
          1
        )
      ]),
      _vm.openSectionProcess
        ? _c("row-detail", {
            staticClass: "mt-3 bg-white",
            attrs: { model: this.process },
            on: { "on-save": _vm.processAction }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }